import {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';

import {TEditableColumn, generateEditableMetadata} from 'components/editable-table';
import {IFieldMeta, selectMetadata, loadMetadata} from 'entities/metadata';
import {EEntityType} from 'shared/constants/entities';
import {useAppSelector} from 'store/config/hooks';

export const useEditableTableColumns = (
    entityName: string,
) => {
    const dispatch = useDispatch();
    const [columnsMeta, setColumnsMeta] = useState<TEditableColumn[] | undefined>();
    const metadata = useAppSelector(state => selectMetadata(entityName, EEntityType.EDITABLE_TABLE)(state));

    useEffect(() => {
        const shouldLoadMetadata = !metadata;
        const fields = metadata?.fields;
        if (shouldLoadMetadata) {
            dispatch(loadMetadata(entityName, EEntityType.EDITABLE_TABLE));
            return;
        }
        if (fields) {
            const arr = (fields as IFieldMeta[])?.map(item => generateEditableMetadata(item));
            setColumnsMeta(arr);
        }
    }, [metadata]);

    return {columnsMeta};
};
